import { useState } from "react";

import { ModalProps } from "@app/analytics/components/BasicModal";
import { EnterpriseTeam } from "@app/common/workspaces/types";

import AddTeamMembersModal from "./AddTeamMembersModal";
import NewTeamModal from "./NewTeamModal";

const CreateTeamModals = ({ onClose, open }: ModalProps) => {
  const [team, setTeam] = useState<EnterpriseTeam | null>(null);
  const [currentStep, setCurrentStep] = useState<"newTeam" | "addTeamMembers">(
    "newTeam"
  );

  const handleNext = (team: EnterpriseTeam) => {
    setTeam(team);
    setCurrentStep("addTeamMembers");
  };

  const handleCloseOnSecondStep = () => {
    setCurrentStep("newTeam");
    onClose();
  };

  return (
    <>
      <AddTeamMembersModal
        onClose={handleCloseOnSecondStep}
        open={open}
        team={team}
        visible={currentStep === "addTeamMembers"}
      />
      <NewTeamModal
        onClose={onClose}
        onNext={handleNext}
        open={open}
        visible={currentStep === "newTeam"}
      />
    </>
  );
};

export default CreateTeamModals;
